module.exports = __webpack_public_path__ + "static/media/icon-guy-key.74cd9ef2.svg";